import './App.css';
import Navbar from './components/navbar/Navbar';
import Home from './views/Home';
import Footer from "./components/footer/Footer";

function App() {
  return (
    <div>
      <Navbar />

      <Home />

      <Footer/>
    </div>
  );
}

export default App;
